import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import {SubmitButton} from '../../buttons/SubmitButton';
import {Spinner} from '../../Spinner';

export function ActivityLogCommentModal({isOpen, toggle, businessUnits, onSubmit, isSubmitting}) {
    const {t} = useTranslation();
    const [commentText, setCommentText] = useState('');
    const [buId, setBuId] = useState('');

    const handleSubmit = () => {
        if (!commentText.trim()) return;
        onSubmit(commentText, buId || null);
    };

    const handleClose = () => {
        setCommentText('');
        setBuId('');
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>{t('activity_log.add_comment')}</ModalHeader>
            {/* `ModalBody`: el padding de `.modal-section` cuelga de `.modal-body`, así que sin él
                el formulario iba pegado a los bordes del modal (QA del 25/09, QA-VIS-historial-09). */}
            <ModalBody>
                <div className="modal-section activity-log-comment-form">
                    <div className="form-row">
                        <label>{t('activity_log.comment_placeholder')}</label>
                        <textarea
                            value={commentText}
                            onChange={(e) => setCommentText(e.target.value)}
                            rows="4"
                        />
                    </div>

                    <div className="form-row">
                        <label>{t('activity_log.no_business_unit')}</label>
                        <select value={buId} onChange={(e) => setBuId(e.target.value)}>
                            <option value="">{t('activity_log.no_business_unit')}</option>
                            {businessUnits.map(bu => (
                                <option key={bu.id} value={bu.id}>{bu.name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="submit-row">
                        {isSubmitting ? (
                            <Spinner color="positive small"/>
                        ) : (
                            <SubmitButton
                                onClick={handleSubmit}
                                value={t('activity_log.publish_comment')}
                            />
                        )}
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
}
